import { ITheme } from "../../utils/theme";

export const noShiftsTextStyle = {
  mb: 1,
  textAlign: 'center',
  color: (theme: ITheme) => theme.palette.black
}

export const containerStyle = {
  background: (theme: ITheme) => theme.palette.common.white,
}

export const alertButtonStyle = {
  color: (theme: ITheme) => theme.palette.warning.light,
  fontWeight: 'bold',
  float: 'right'
}

export const shiftCardWrapperStyle = (theme: ITheme, otherTimeNumber = 0) => ({
  p: 1,
  borderBottom: otherTimeNumber === 6 ? `1px solid ${theme.palette.grey[300]}` : 'none',
  display: 'flex',
  justifyContent: 'space-between',
  ml: otherTimeNumber === 0 ? 0 : 3,
  flexDirection: { xs: 'column', md: 'row' }
})

export const availableLabelStyle = {
  color: (theme: ITheme) => theme.palette.red.A700,
  fontWeight: 'bold',
  '&.available': {
    color: (theme: ITheme) => theme.palette.green[600],
  },
  textTransform: 'capitalize',
  display: 'flex',
  alignItems: { xs: 'flex-start', md: 'center' },
  mt: { xs: 1, md: 0 },
  ml: { xs: '30px', md: 0 }
}
